// extracted by mini-css-extract-plugin
export default {"root":"qDSBo2","row":"lp1vfd","text":"biwnpD","date":"AgwTCB","total":"fJoXeo","arrow":"gGxLR3"};